import "core-js/modules/es6.array.map";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import { get, objectKeys } from "@chakra-ui/utils";
/**
 * Transform an object of style props config to it's raw values.
 *
 * @param config the parser config object
 * @param theme the theme object
 */

export function transformConfig(config, theme) {
  var result = {};
  objectKeys(config).forEach(function (prop) {
    var propConfig = config[prop];
    /**
     * if a config doesn't exist for this style prop, return (no-op)
     */

    if (propConfig === null) return;
    /**
     * If prop's config is `true`, then it maps directly
     * to the css property.
     *
     * This is useful in providing a regular css property
     * as a style prop.
     */

    if (propConfig === true) {
      result[prop] = {
        property: prop
      };
      return;
    }

    var property = propConfig.property,
        properties = propConfig.properties,
        scale = propConfig.scale,
        transform = propConfig.transform,
        fallbackScale = propConfig.fallbackScale,
        rest = _objectWithoutPropertiesLoose(propConfig, ["property", "properties", "scale", "transform", "fallbackScale"]);

    var _scale = scale && get(theme, scale, fallbackScale);

    if (property) {
      result[prop] = _extends({
        property: property
      }, rest);

      if (transform) {
        result[prop]["transform"] = transform;
      }

      if (scale) {
        result[prop]["scale"] = _scale;
      }

      return;
    }

    if (properties) {
      result[prop] = properties.map(function (property) {
        var mapResult = _extends({
          property: property
        }, rest);

        if (transform) {
          mapResult["transform"] = transform;
        }

        if (scale) {
          mapResult["scale"] = _scale;
        }

        return mapResult;
      });
      return;
    }

    result[prop] = propConfig;
  });
  return result;
}